// Pure helpers extracted from PrimaryWheel/index.jsx so the Primary-Wheel card's
// wallpaper-resolution (PW-01) and description-cleaning (PW-03) logic is
// unit-testable WITHOUT rendering the (large, CRITICAL-complexity) PrimaryWheel
// component. Behaviour is byte-identical to the previous inline definitions —
// this is a retrofit, not a change (same repo pattern as favoriteAffordance.js
// and moveToTeamLogic.js extracted from WheelCardThreeDotMenu).
import { sanitizeUserHtml } from "../../../utils/sanitizeHtml";

// PW-01: a background string is treated as an IMAGE only when it looks like a
// URL (http/https/data). Image → cover the card; otherwise use it as a raw CSS
// color, falling back to the card's neutral #F6F7F9 when empty.
export const getBackground = (bg) => {
  const isImageUrl = (value) => /^(http|https|data):/.test(value);
  return isImageUrl(bg) ? `url(${bg}) center/cover no-repeat` : bg || "#F6F7F9";
};

// PW-01: for a v2 wheel the card background comes from wallpaper_settings —
// current_bg 2 or 3 means "use the wallpaper image", anything else means "use
// the flat segment color".
export const getWheelBackground = (wallpaperSettings = {}) => {
  const { bg_wallpaper, current_bg, segment_bg_color } = wallpaperSettings || {};
  return current_bg === 2 || current_bg === 3 ? bg_wallpaper : segment_bg_color;
};

// PW-01: the full card-background decision. A v1 wheel carries a flat
// `wallpaper` field; a v2 wheel resolves through wallpaper_settings.
export const resolvePrimaryBackground = (primaryWheel) =>
  primaryWheel?.version === 1
    ? getBackground(primaryWheel?.wallpaper)
    : getBackground(getWheelBackground(primaryWheel?.wallpaper_settings));

// PW-03: strip the leading whitespace / empty tags a ContentEditable description
// accumulates, then hand off to the (flag-gated, default-passthrough) HTML
// sanitizer. Null/empty → empty string.
export const cleanDescriptionHtml = (html) => {
  if (!html) return "";

  // Remove leading whitespace and line breaks
  let cleaned = html.replace(/^\s+/, "");

  // Remove leading empty tags with whitespace
  cleaned = cleaned.replace(/^(<[^>]*>)*\s+/, "$1");

  // Remove leading <br> tags
  cleaned = cleaned.replace(/^(<br\s*\/?>)+/i, "");

  // Remove leading <p> tags that only contain whitespace
  cleaned = cleaned.replace(/^<p[^>]*>\s*<\/p>/i, "");

  return sanitizeUserHtml(cleaned);
};

// PW-03: true when the (cleaned) description has no visible text AND no embedded
// media — media-aware so an image-only description is NOT mistaken for empty.
export const isDescriptionEmpty = (html) => {
  const cleaned = cleanDescriptionHtml(html);
  if (!cleaned) return true;
  if (/<(img|video|iframe|audio)\b/i.test(cleaned)) return false;
  return cleaned.replace(/<[^>]*>|&nbsp;/gi, "").trim().length === 0;
};
